// Used during logout to bypass the iframe postMessage mechanism.
export const windowUrlOpener = (url: string) => {
  window.location.href = url;
};

export const openInNewWindowUrlOpener = (url: string) => {
  window.open(url, '_blank');
};
